module.exports = __webpack_public_path__ + "static/media/iamrapun.0190c7b1.jpeg";